import React, { Component } from 'react';
import { NavLink, Route, withRouter } from 'react-router-dom';

import { routes } from '../../../../../routes';
import { apiGetUser } from '../../../../../api/user';

import Card from '../../../../../components/Card';
import FlaggedUserModal from '../../../../../components/Modal/FlaggedUserModal';
import Info from './Info';
import Registrations from './Registrations';
import Certifications from './Certifications';
import Notes from './Notes';
import Payments from './Payments';
import ProfileCertification from './Certification';
import NewRegistration from './Registration';
import Memberships from './Memberships';
import Groups from './Groups';
import Flags from './Flags';

class Profile extends Component {
  state = {
    loaded: false,
    user: null,
  };

  componentDidMount() {
    const { match } = this.props;
    const selectedUserId = match.params.id;

    apiGetUser(selectedUserId).then(({ data }) => this.setState({ user: data, loaded: true }));
  }

  updateUser = (newUser) => this.setState({ user: newUser });
  updateUserPayments = (newPayments) =>
    this.setState({ user: { ...this.state.user, certificationPayments: newPayments } });

  render() {
    if (!this.state.loaded) return <noscript />;
    const { user } = this.state;
    const sectionProps = {
      ...this.props,
      ...this.state,
      updateUser: this.updateUser,
      updateUserPayments: this.updateUserPayments,
    };

    return (
      <div>
        <div className="row">
          {user && (
              <FlaggedUserModal
                user={user}
              >
              </FlaggedUserModal>
            )}
        </div>
        <div className="row">
          <div className="col-md-3 mb-3">
            <Card>
              <Card.Header>
                {user.firstName} {user.lastName}
              </Card.Header>
              <Card.Body>
                <div className="nav flex-column nav-pills" role="tablist" aria-orientation="vertical">
                  <NavLink exact to={routes.admin.users.profile.rootBuilder(user.id)} className="nav-link">
                    Info
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.registrationsBuilder(user.id)} className="nav-link">
                    Registrations
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.certificationsBuilder(user.id)} className="nav-link">
                    Certifications
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.membershipsBuilder(user.id)} className="nav-link">
                    Memberships
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.notesBuilder(user.id)} className="nav-link">
                    Notes
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.flagsBuilder(user.id)} className="nav-link">
                    Flags
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.paymentsBuilder(user.id)} className="nav-link">
                    Payments
                  </NavLink>
                  <NavLink to={routes.admin.users.profile.groupsBuilder(user.id)} className="nav-link">
                    Groups
                  </NavLink>
                  <a href={`/impersonate/take/${user.id}`} className="nav-link">
                    Impersonate
                  </a>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="tab-content col-md-9" id="tabContent">
            <Route exact path={routes.admin.users.profile.root} render={() => <Info {...sectionProps} />} />
            <Route
              exact
              path={routes.admin.users.profile.registrations}
              render={() => <Registrations {...sectionProps} />}
            />
            <Route
              path={routes.admin.users.profile.newRegistration}
              render={() => <NewRegistration {...sectionProps} />}
            />
            <Route
              exact
              path={routes.admin.users.profile.certifications}
              render={() => <Certifications {...sectionProps} />}
            />
            <Route
              path={routes.admin.users.profile.certification}
              render={() => <ProfileCertification {...sectionProps} />}
            />
            <Route path={routes.admin.users.profile.memberships} render={() => <Memberships {...sectionProps} />} />
            <Route path={routes.admin.users.profile.notes} render={() => <Notes {...sectionProps} />} />
            <Route path={routes.admin.users.profile.flags} render={() => <Flags {...sectionProps} />} />
            <Route path={routes.admin.users.profile.payments} render={() => <Payments {...sectionProps} />} />
            <Route path={routes.admin.users.profile.groups} render={() => <Groups {...sectionProps} />} />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Profile);
